export default new Set([
  'getnada.com',
  'abyssmail.com',
  'dropjar.com',
  'givmail.com',
  'inboxbear.com',
  'robot-mail.com',
  'tafmail.com',
  'vomoto.com',
  'enhancedzoom.com',
  'labworld.org',
  'dollstore.org',
  'coffeetimer24.com',
  'plancetose.com',
  'klovenode.com',
  'happy2023year.com',
  'waterisgone.com',
  'gixenmixen.com',
  'dishcatfish.com',
  'tozya.com',
  'techmailer.host',
  'katgetmail.space',
  'gettempmail.site',
  'mailto.plus',
  'fexpost.com',
  'fexbox.org',
  'mailbox.in.ua',
  'rover.info',
  'intopwa.com',
  'tofeat.com',
  'chitthi.in',
  'highmail.my.id',
  'whatisakilowatt.com',
  'luxusmail.my.id',
  'neverthought.lol',
  'explodemail.com',
  'email.ucms.edu.pk',
]);
